import { GrantsType, hasScopedPermission } from 'Shared/utils/auth';

export const updatePortalUserPartner = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'portal_users.change_partner') ||
  hasScopedPermission(grants, 'system', 'portal_users.change_partner');
